export const frenchAlphabet = [
  {
    letter: "А",
    color: "#F06543",
    src: 'pineapplePng',
    name: "test",
  },
  {
    letter: "B",
    color: "#F99B28",
    borderColor: "#A82525",
    src: 'bananaPng',
    name: "Banana",
  },
  {
    letter: "C",
    color: "#FEF723",
    borderColor: "#A82525",
    src: 'catPng',
    name: "Cat",
  },
  {
    letter: "D",
    color: "#B5D444",
    borderColor: "#A82525",
    src: 'dogPng' ,
    name: "Dog",
  },
  {
    letter: "E",
    color: "#0AADE8",
    borderColor: "#A82525",
    src: 'elephantPng',
    name: "Elephant",
  },
  {
    letter: "F",
    color: "#EA259D",
    borderColor: "#A82525",
    src: 'foxPng',
    name: "Fox",
  },
  {
    letter: "G",
    color: "#363190",
    borderColor: "#A82525",
    src: 'giraffePng',
    name: "Giraffe",
  },
  {
    letter: "H",
    color: "#F9403C",
    borderColor: "#A82525",
    src: 'hatPng',
    name: "Hat",
  },
  {
    letter: "I",
    color: "#F5901E",
    borderColor: "#A82525",
    src:'ice_creamPng',
    name: "Ice Cream",
  },
  {
    letter: "J",
    color: "#FFF11A",
    borderColor: "#A82525",
    src: 'juicePng',
    name: "Juice",
  },
  {
    letter: "K",
    color: "#B7D340",
    borderColor: "#A82525",
    src: 'keyPng',
    name: "Key",
  },
  {
    letter: "L",
    color: "#0AADE9",
    borderColor: "#A82525",
    src: 'lionPng',
    name: "Lion",
  },
  {
    letter: "M",
    color: "#EA008D",
    borderColor: "#A82525",
    src: 'mousePng',
    name: "Mouse",
  },
  {
    letter: "N",
    color: "#2E2B92",
    borderColor: "#A82525",
    src: 'nutPng',
    name: "Nut",
  },
  {
    letter: "O",
    color: "#F6A01A",
    borderColor: "#A82525",
    src:'orangePng',
    name: "Orange",
  },
  {
    letter: "P",
    color: "#F59120",
    borderColor: "#A82525",
    src: 'pandaPng',
    name: "Panda",
  },
  {
    letter: "Q",
    color: "#F8EA13",
    borderColor: "#A82525",
    src: 'queenPng',
    name: "Queen",
  },
  {
    letter: "R",
    color: "#B3D43A",
    borderColor: "#A82525",
    src: 'rabbitPng',
    name: "Rabbit",
  },
  {
    letter: "S",
    color: "#04ACE4",
    borderColor: "#A82525",
    src: 'sunPng',
    name: "Sun",
  },
  {
    letter: "T",
    color: "#D9077D",
    borderColor: "#A82525",
    src: 'tigerPng',
    name: "Tiger",
  },
  {
    letter: "U",
    color: "#2E2E8C",
    borderColor: "#A82525",
    src: 'unicornPng',
    name: "Unicorn",
  },
  {
    letter: "V",
    color: "#ED3131",
    borderColor: "#A82525",
    src: 'vasePng',
    name: "Vase",
  },
  {
    letter: "W",
    color: "#F7901B",
    borderColor: "#A82525",
    src: 'wolfPng',
    name: "Wolf",
  },
  {
    letter: "X",
    color: "#F9F506",
    borderColor: "#A82525",
    src: 'xylophonePng',
    name: "Xylophone",
  },
  {
    letter: "Y",
    color: "#B7D64A",
    borderColor: "#A82525",
    src: 'yoyoPng',
    name: "Yoyo",
  },
  {
    letter: "Z",
    color: "#02AFE8",
    borderColor: "#A82525",
    src: 'zebraPng',
    name: "Zebra",
  },
];